<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="p-0 flex flex-col bg-[#FFFFFF] rounded-[16px] font-[Gilroy]">
            <div class="flex flex-col gap-2">
                <div class="flex w-full gap-4 justify-between items-center p-4">
                    <p class="text-primary font-semibold mobile:text-sm">{{
                        'admin.add_agent' | transloco
                        }}
                    </p>
                </div>
                <div class="flex">
                    <div class="h-[2px] bg-primary min-w-[200px] mobile:w-full"></div>
                    <div class="flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col p-4 gap-2">
                <div class="flex flex-col gap-2 px-1 overflow-y-auto">
                    <div class="w-full flex flex-col gap-2 my-5">
                        <!-- Street input -->
                        <div class="w-full self-center min-w-[250px]">
                            <app-labeled-input labelText="{{ 'admin.name' | transloco }}" [inputId]="'name'"
                                [inputType]="'text'" [(inputValue)]="nameInput" [errorMessage]="nameInputError"
                                placeholder="{{ 'admin.name' | transloco }}"></app-labeled-input>
                        </div>
                        <!-- Nr input -->
                        <div class="w-full self-center min-w-[250px]">
                            <app-labeled-input labelText="{{ 'admin.email' | transloco }}" [inputId]="'email'"
                                [inputType]="'text'" [(inputValue)]="emailInput" [errorMessage]="emailInputError"
                                placeholder="{{ 'admin.email' | transloco }}"></app-labeled-input>
                        </div>
                        <!-- Postal Code input -->
                        <div class="w-full self-center min-w-[250px]">
                            <app-labeled-input labelText="{{ 'admin.contact_number' | transloco }}"
                                [inputId]="'contactNumber'" [inputType]="'text'" [(inputValue)]="contactNumberInput"
                                [errorMessage]="contactNumberInputError"
                                placeholder="{{ 'admin.contact_number' | transloco }}"></app-labeled-input>
                        </div>
                    </div>
                </div>
                <div *ngIf="dialogErrorMessage" class="flex items-center text-error mt-2 text-sm">
                    <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
                        class="w-5 h-5" />
                    <p class="ml-1">{{ dialogErrorMessage }}</p>
                </div>
                <div class="flex w-full gap-4">
                    <div class="flex-[1] h-[45px]">
                        <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" (buttonClick)="closeModal()"
                            backgroundColor="bg-[#FFFFFF]" textColor="text-secondary" borderColor="border-secondary"
                            hoverBackgroundColor="hover:bg-secondary"
                            hoverBorderColor="hover:border-secondary"></app-custom-button>
                    </div>
                    <div class="flex-[1] h-[45px]">
                        <app-custom-button buttonText="{{ 'shared.confirm' | transloco }}"
                            (buttonClick)="confirmButtonClick()" backgroundColor="bg-primary" textColor="text-white"
                            borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200"
                            [isDisabled]="confirmClicked"></app-custom-button>
                    </div>
                </div>

            </div>
        </div>
    </ng-template>
</p-dialog>